/*
 * @Author: your name
 * @Date: 2021-06-25 11:23:51
 * @LastEditTime: 2022-01-18 10:17:08
 */
import http from './http'

export default class ConsoleApi{
	// 网站数量接口
	static getSitesCount(data) {
		return http.httpGet('/project/count', data)
	}
	// 网站数量接口
	static getSitesList(data) {
		return http.httpGet('/project/list', data)
	}
	// 可用空间数量
	static getSpace(data) {
		return http.httpGet('/project/getspace', data)
	}
	// 是否允许创建响应式
	static checkResponsiveSpace(data) {
		return http.httpGet('/project/checkResponsiveSpace', data)
	}
	//新闻和产品发布量接口
	static getArticleProduct(data) {
		return http.httpGet('/project/getArticleProduct', data)
	}
	//体验站变更
	static updateExperience(data) {
		return http.httpGet('/project/updateExperience', data)
	}

}
